// extracted by mini-css-extract-plugin
export var img = "banner-module--img--h8eU4";
export var wrapper = "banner-module--wrapper--F50rO";